import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Http } from '../../../../helpers/axois'
import { IApp } from '../type'
import { appMapper } from '../helpers'
import { defaultApp } from '../constants'
import { AppState } from "../../../../stateManager/store";
import { pushToast } from '../../../../stateManager/store/toast/actions';
import { useToast } from '../../../../helpers/commonFunction'
interface IState {
  loading: boolean
  app: IApp
}

export const useApp = (appId: string) => {
  const {ErrorToast}=useToast();
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const orgId = useSelector((state: AppState) => state.org.selectedOrg?.id);
  const [state, setState] = useState<IState>({
    loading: true,
    app: defaultApp,
  })
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })

  const getApp = async (appId: string, orgId: string) => {
    if ((!orgPermissions?.includes("marketplace.PublishApp") || !orgPermissions.includes('org.View')) &&  loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Error fetching marketplace apps")
      return
    }
    const endpoint = `orgs/${orgId}/marketplaceApps/${appId}`
    try {
      const { data: app } = await Http.get(endpoint).toPromise()
      setState((prevState) => ({ ...prevState, app: appMapper(app) }))
    } catch (err) {
      if (err === "Forbidden") {
        pushToast && pushToast(
          { type: 'error', message: 'Not Authorized: Error fetching marketplace apps' }
        )
      }
      console.error('failed to get marketplace app: ', err)
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }))
    }
  }

  useEffect(() => {
    getApp(appId, orgId)
  }, [appId, orgId])

  return state
}
